import { motion } from "framer-motion";
import { ReactNode } from "react";

interface ButtonsGroupProps {
    children: ReactNode;
    animated?: boolean;
}

export const ButtonsGroup = ({ children, animated = true }: ButtonsGroupProps) => {
    return (
        <motion.div
            initial={animated ? { opacity: 0 } : { opacity: 1 }}
            animate={{ opacity: 1 }}
            transition={animated ? { duration: 0.5, delay: 1 } : { duration: 0 }}
            className="flex flex-col items-center gap-2 w-full"
        >
            {children}
        </motion.div>
    );
}; 